import type { ReactNode } from "react";
import "./DateDisplay.scss";
import useDateFormat from "@/shared/utils/useDateFormat.ts";
import { DateStyle } from "@/shared/utils/Dates.ts";
import type { DateTime } from "luxon";
interface Properties {
  value: DateTime;
  timeZone: string;
  onClick: () => void;
}

export default function DateDisplay(props: Properties): ReactNode {
  const formatDate = useDateFormat(
    DateStyle.WEEKDAY_SHORT_DATE_MONTH_SHORT,
    props.timeZone,
  );
  const formatYear = useDateFormat(DateStyle.YEAR, props.timeZone);
  return (
    <div className="date-display" onClick={props.onClick}>
      <div className="day">{formatDate(props.value.toJSDate())}</div>
      <div className="year">{formatYear(props.value.toJSDate())}</div>
    </div>
  );
}
